import React from 'react'
import { 
  ChartBarIcon, 
  ShoppingCartIcon, 
  ClockIcon,
  CurrencyDollarIcon
} from '@heroicons/react/24/outline'

interface LoadingScreenProps {
  /** Optional loading icon from restaurant settings (used on admin, waiter, customer menu). */
  loadingIconUrl?: string
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ loadingIconUrl }) => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        {/* Logo: custom loading icon from settings or default */}
        <div className="mb-8">
          <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4 animate-pulse overflow-hidden bg-primary-600">
            {loadingIconUrl ? (
              <img src={loadingIconUrl} alt="" className="w-full h-full object-contain p-2" />
            ) : (
              <span className="text-white font-bold text-2xl">M</span>
            )}
          </div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            POS by Mufaza
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            Restaurant Management System
          </p>
        </div>

        {/* Loading animation */}
        <div className="flex justify-center space-x-2 mb-8">
          <div className="w-3 h-3 bg-primary-600 rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-primary-600 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-3 h-3 bg-primary-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>

        {/* Feature icons */}
        <div className="flex justify-center space-x-8 text-gray-400 dark:text-gray-500">
          <div className="flex flex-col items-center">
            <ChartBarIcon className="h-8 w-8 mb-2" />
            <span className="text-sm">Analytics</span>
          </div>
          <div className="flex flex-col items-center">
            <ShoppingCartIcon className="h-8 w-8 mb-2" />
            <span className="text-sm">POS</span>
          </div>
          <div className="flex flex-col items-center">
            <ClockIcon className="h-8 w-8 mb-2" />
            <span className="text-sm">Real-time</span>
          </div>
          <div className="flex flex-col items-center">
            <CurrencyDollarIcon className="h-8 w-8 mb-2" />
            <span className="text-sm">Payments</span>
          </div>
        </div>

        {/* Loading text */}
        <div className="mt-8">
          <p className="text-gray-600 dark:text-gray-400">
            Initializing your restaurant management system...
          </p>
        </div>
      </div>
    </div>
  )
}

export default LoadingScreen

